import { ShipmentForm } from '../hooks/shipmentForm/useShipmentForms';

/**
 * Airway bills belong to a specific shipment form: the MAWB (no parent) or one
 * of its HAWBs. Build a lookup from document id to its "MAWB" / "HAWB n" tag so
 * document lists can tell otherwise-identical "Airway Bill" rows apart. HAWBs
 * are numbered in the same order the paperwork UI lists them.
 */
export const buildAwbDocumentLabels = (shipmentForms?: ShipmentForm[]): Record<number, string> => {
  const labels: Record<number, string> = {};

  const mawb = shipmentForms?.find((form) => !form.parent_shipment_form_id);
  if (!mawb) return labels;

  mawb.documents?.forEach((doc) => {
    labels[doc.id] = 'MAWB';
  });

  shipmentForms
    ?.filter((form) => form.parent_shipment_form_id === mawb.id)
    .forEach((hawb, index) => {
      hawb.documents?.forEach((doc) => {
        labels[doc.id] = `HAWB ${index + 1}`;
      });
    });

  return labels;
};
